import React from "react";
import clsx from "clsx";
import { twMerge } from "tailwind-merge";
import { useLocation } from "react-router-dom";
import ChevronDown from "@ht/shared/fonts/deos-pis/chevron-down";
import { Menu } from "../../../app/auth/types";
import NotificationBubble from "../../../components/notification-bubble";
import { Dropdown, DropdownToggle, DropdownMenu, Anchor } from '@ht/components';

interface Props {
    menu: Menu[];
}

const SubMenu: React.FC<Props> = ({ menu }) => {
    return (
        <ul className="absolute top-full left-1/2 -translate-x-1/2 hidden z-10 group-hover:block">
            <div className="w-[448px] flex flex-wrap bg-white mt-5 px-4 py-2.5 shadow-lg rounded-lg">
                {menu.map((nav) => {
                    return (
                        <li
                            key={nav.id}
                            className="w-1/2 flex items-center justify-start p-2 gap-2.5"
                        ></li>
                    );
                })}
            </div>
        </ul>
    );
};

const MainMenu: React.FC<Props> = ({ menu }) => {
    const location = useLocation();
    let countBaseMenu = 0;
    let countMoreMenu = 0;
    const baseMenu = menu?.map((item) => {
        countBaseMenu++
        if (countBaseMenu < 4) {
            return item;
        }
    });
    const moreMenu = menu?.map((itemc) => {
        countMoreMenu++
        if (countMoreMenu > 3) {
            return itemc;
        }
    });
    const baseMenuFilter = baseMenu?.filter(Boolean);
    const moreMenuFilter = moreMenu?.filter(Boolean);

    return (
        <nav className="hidden mx-10 lg:block">
            <ul className="flex items-center gap-10 text-md">
                {baseMenuFilter?.map((nav) => {
                    const { submenu } = nav!;
                    const hasChildren = submenu
                        ? submenu.filter(
                            (x) =>
                                x.position === "TOP" || x.position === "BOTH"
                        ).length > 0
                        : false;

                    const active =
                        nav?.url === "/"
                            ? location.pathname === nav?.url
                            : location.pathname.includes(nav?.url as string);

                    return (
                        <li
                            key={nav?.id}
                            className={clsx("cursor-pointer", {
                                "flex items-center gap-1 relative group":
                                    hasChildren,
                            })}
                        >
                            <Anchor
                                className={twMerge(
                                    clsx(
                                        "text-primary-400 font-semibold text-md px-1.5 relative ",
                                        {
                                            "text-white": active,
                                        }
                                    )
                                )}
                                path={nav?.url as string}
                            >
                                <NotificationBubble url={nav?.url as string} />{nav?.label}
                            </Anchor>
                            {hasChildren && (
                                <>
                                    <ChevronDown className={clsx("w-3 h-2")} />
                                    {!!submenu && <SubMenu menu={submenu} />}
                                </>
                            )}
                        </li>
                    );
                })}
                {moreMenuFilter?.length > 0 &&
                    <div className="flex flex-row">
                        <Dropdown className="flex flex-row justify-center items-center" direction="down" showIcon={false} shape>
                            <DropdownToggle
                                variant="outlined"
                                iconButton
                                className="text-primary-400 font-semibold text-md relative"
                            >
                                <div className="flex flex-row">
                                    <div className="text-primary-400 font-semibold text-md relative hover:text-gray-150">
                                        More
                                    </div>
                                    <ChevronDown className={clsx("w-3 h-2 ml-1 mt-2")} />
                                </div>
                            </DropdownToggle>
                            <DropdownMenu
                                className={clsx(
                                    "rounded p-1.5 !w-[11rem] mt-3 -mr-[1.75rem] border-t-0 right-0 left-auto"
                                )}
                            >
                                {moreMenuFilter?.map((nav) => {
                                    return (
                                        <li
                                            key={nav?.id}
                                            className={clsx("cursor-pointer mt-3")}
                                        >
                                            <Anchor
                                                className={twMerge(
                                                    clsx(
                                                        "text-black font-semibold text-md px-1.5 hover:text-primary"
                                                    )
                                                )}
                                                path={nav?.url as string}
                                            >
                                                <NotificationBubble url={nav?.url as string} />{nav?.label}
                                            </Anchor>
                                        </li>
                                    );
                                })}
                            </DropdownMenu>
                        </Dropdown>
                    </div>
                }
            </ul>
        </nav>
    );
};

export default MainMenu;
